import ProjectHeader from "@/apps/riyasol/modules/projects/components/project-header"
import { DataTable, List } from "@/components/admin"
// const Actions = () => (
//   <div className="flex items-center gap-2 pt-4">
//     <CreateButton />
//   </div>
// )
const ProjectList: React.FC = () => {
  return (
    <List>
      <DataTable bulkActionButtons={false}>
        <DataTable.Col
          render={({
            id,
            title,
            status,
            city,
            region,
            surface,
            floors,
            bedrooms,
          }) => (
            <ProjectHeader
              key={id}
              {...{
                id,
                title,
                status,
                city,
                region,
                surface,
                floors,
                bedrooms,
              }}
            />
          )}
        />
      </DataTable>
    </List>
  )
}

export default ProjectList

{
  /* <ProjectHeader
                  key={id}
                  {...{
                    id,
                    title,
                    status,
                    city,
                    region,
                    surface,
                    floors,
                    bedrooms,
                  }}
                ></ProjectHeader> */
}
